import React from "react";
import { Container, Typography, Box, Paper } from "@mui/material";

// Import social media images
import Youtube from "../images/yt.png";
import Tweet from "../images/tweet.png";
import Linkedin from "../images/Linkedin.png";
import Instagram from "../images/Insta.png";
import Facebook from "../images/facebook.png";
import Web from "../images/Web.png";

const Footer = () => {
  return (
    <Container
      maxWidth="lg"
      sx={{
        mt: { xs: 3, sm: 4, md: 5, lg: 6, xl: 6 }, // Responsive margin top
        py: { xs: 2, sm: 3, md: 4, lg: 4, xl: 4 }, // Responsive padding vertical
        textAlign: "center",
        borderTop: "1px solid #999999",
      }}
    >
      <Paper
        elevation={3} // Elevation creates the shadow effect
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" }, // Stack on mobile, row on tablets and larger
          justifyContent: "space-between", // Evenly space items horizontally on larger screens
          alignItems: "center",
          backgroundColor: "white", // Set background to white
          borderRadius: 3, // Smoother rounded corners
          paddingX: { xs: 2, sm: 3, md: 4, lg: 5, xl: 6 }, // Responsive horizontal padding
          paddingY: { xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }, // Responsive vertical padding
          border: "1px solid #ddd",
          boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
          gap: { xs: 2, sm: 1, md: 0 }, // Responsive gap between items
        }}
      >
        <Typography
          fontFamily="Light"
          variant={{ xs: "h6", sm: "h6", md: "h5", lg: "h5", xl: "h4" }} // Responsive variant
          sx={{
            mb: { xs: 1, sm: 0 }, // Margin bottom only on mobile
            color: "#002367", // Blue color for "Follow Us"
            fontSize: { xs: 16, sm: 18, md: 20, lg: 22, xl: 24 }, // Responsive font size
          }}
        >
          Follow Us
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" }, // Stack on mobile, row on tablets and larger
            flexWrap: "wrap", // Allow wrapping on smaller screens
            justifyContent: { xs: "flex-start", sm: "center" }, // Center items on mobile
            alignItems: { xs: "flex-start", sm: "center" },
            gap: { xs: 2, sm: 1, md: 1, lg: 1.5, xl: 2 }, // Responsive gap
          }}
        >
          <Typography
            fontFamily="Light"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              // gap: 1,
            }}
          >
            <img
              src={Web}
              alt="Website"
              className="cu_img"
              style={{
                width: { xs: 20, sm: 25, md: 30, lg: 35, xl: 40 }, // Responsive image size
                height: "auto",
                objectFit: "contain",
              }}
            />
            <a
              href="http://sstus.net/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#002367",
                textDecoration: "none",
                fontSize: { xs: 12, sm: 14, md: 16, lg: 18, xl: 20 }, // Responsive font size
                "&:hover": { textDecoration: "underline" },
              }}
            >
              Website
            </a>
          </Typography>
          <Typography
            fontFamily="Light"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              // gap: 1,
            }}
          >
            <img
              src={Facebook}
              alt="Facebook"
              className="cu_img"
              style={{
                width: { xs: 20, sm: 25, md: 30, lg: 35, xl: 40 }, // Responsive image size
                height: "auto",
                objectFit: "contain",
              }}
            />
            <a
              href="https://www.facebook.com/NJShriSaiTechnology/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#002367",
                textDecoration: "none",
                fontSize: { xs: 12, sm: 14, md: 16, lg: 18, xl: 20 }, // Responsive font size
                "&:hover": { textDecoration: "underline" },
              }}
            >
              Facebook
            </a>
          </Typography>
          <Typography
            fontFamily="Light"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              // gap: 1,
            }}
          >
            <img
              src={Instagram}
              alt="Instagram"
              className="cu_img"
              style={{
                width: { xs: 20, sm: 25, md: 30, lg: 35, xl: 40 }, // Responsive image size
                height: "auto",
                objectFit: "contain",
              }}
            />
            <a
              href="https://www.instagram.com/shri_saitech/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#002367",
                textDecoration: "none",
                fontSize: { xs: 12, sm: 14, md: 16, lg: 18, xl: 20 }, // Responsive font size
                "&:hover": { textDecoration: "underline" },
              }}
            >
              Instagram
            </a>
          </Typography>
          <Typography
            fontFamily="Light"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              // gap: 1,
            }}
          >
            <img
              src={Linkedin}
              alt="LinkedIn"
              className="cu_img"
              style={{
                width: { xs: 20, sm: 25, md: 30, lg: 35, xl: 40 }, // Responsive image size
                height: "auto",
                objectFit: "contain",
              }}
            />
            <a
              href="https://www.linkedin.com/company/72067539"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#002367",
                textDecoration: "none",
                fontSize: { xs: 12, sm: 14, md: 16, lg: 18, xl: 20 }, // Responsive font size
                "&:hover": { textDecoration: "underline" },
              }}
            >
              LinkedIn
            </a>
          </Typography>
          <Typography
            fontFamily="Light"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              // gap: 1,
            }}
          >
            <img
              src={Tweet}
              alt="Twitter"
              className="cu_img"
              style={{
                width: 16, // Reduced width
                height: 16, // Reduced height
                objectFit: "contain",
                marginRight: 5, // Adds spacing between the icon and text
              }}
            />
            <a
              href="https://x.com/ShriSaiTech1"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#002367",
                textDecoration: "none",
                fontSize: { xs: 12, sm: 14, md: 16, lg: 18, xl: 20 }, // Responsive font size
                "&:hover": { textDecoration: "underline" },
              }}
            >
              Twitter
            </a>
          </Typography>
          <Typography
            fontFamily="Light"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
            }}
          >
            <img
              src={Youtube}
              alt="YouTube"
              className="cu_img"
              style={{
                width: { xs: 20, sm: 25, md: 30, lg: 35, xl: 40 }, // Responsive image size
                height: "auto",
                objectFit: "contain",
              }}
            />
            <a
              href="https://www.youtube.com/@SSTAiSolutions"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#002367",
                textDecoration: "none",
                fontSize: { xs: 12, sm: 14, md: 16, lg: 18, xl: 20 }, // Responsive font size
                "&:hover": { textDecoration: "underline" },
              }}
            >
              YouTube
            </a>
          </Typography>
        </Box>
      </Paper>
      <Typography
        fontFamily="Light"
        variant="body2"
        sx={{ paddingY: 4, color: "#06121c" }}
      >
        <b>Copyright</b> SST | All Rights Reserved © {new Date().getFullYear()}
      </Typography>
    </Container>
  );
};

export default Footer;
